import { createReducer } from "@reduxjs/toolkit"
import {
  changeActiveComboChipIndex,
  changeActivePanel,
  changeBadgeName,
  changeBarCodeSettings,
  changeEditType,
  changeFirstLoad,
  changeImageFilters,
  changeImageUpload,
  changeIsLoading,
  changePaintOptions,
  changeTemplateProducts,
  changeDataFields,
  changeTags,
  changeNewDesignOpen,
  changeIsComboCustomStyle,
  changeIsRow,
  openBoothModal,
  openBoothSettingsModal,
  saveAssignedTktIds,
  saveUnAssignedTktIds,
  saveDeletedBoothIds,
  floormapHoverObject,
  changeUserPermisison,
  changeIsImporting
} from "./actions"
import { EditType, TemplateType } from "@store/reducers/init/types"
import { initialState } from "@store/reducers/init/consts"

export const initReducer = createReducer(initialState, (builder) => {
  builder.addCase(
    changeNewDesignOpen,
    (state, { payload }: { payload: { open: boolean; templateType: TemplateType } }) => {
      state.newDesignOpen = payload.open
      state.newDesignTemplateType = payload.templateType
    }
  )
  builder.addCase(changeEditType, (state, { payload }: { payload: EditType }) => {
    state.editType = payload
  })

  //activeComboChipIndex
  builder.addCase(changeActiveComboChipIndex, (state, { payload }) => {
    state.activeComboChipIndex = payload
  })

  //changeIsComboCustomStyle
  builder.addCase(changeIsComboCustomStyle, (state, { payload }) => {
    state.isComboCustomStyle = payload
  })

  //changeIsComboCustomStyle
  builder.addCase(changeIsRow, (state, { payload }) => {
    state.isRow = payload
  })



  builder.addCase(changeImageFilters, (state, { payload }) => {
    state.imageFilters[payload.name] = payload.filters
  })

  builder.addCase(changeTemplateProducts, (state, { payload }) => {
    state.templateProducts = payload
  })

  //BarCodeSettings
  builder.addCase(changeBarCodeSettings, (state, { payload }) => {
    //@ts-ignore
    state.barCodeSettings = payload
  })

  //Active Panel
  builder.addCase(changeActivePanel, (state, { payload }) => {
    //@ts-ignore
    state.activePanel = payload
  })

  //Image Uploads
  builder.addCase(changeImageUpload, (state, { payload }) => {
    //@ts-ignore
    state.imageUploads = payload
  })

  //FirstLoad
  builder.addCase(changeFirstLoad, (state, { payload }) => {
    //@ts-ignore
    state.firstLoad = payload
  })

  builder.addCase(changeBadgeName, (state, { payload }) => {
    //@ts-ignore
    state.badgeName = payload
  })

  //isLoading
  builder.addCase(changeIsLoading, (state, { payload }) => {
    //@ts-ignore
    state.isLoading = payload
  })

  builder.addCase(changePaintOptions, (state, { payload }) => {
    state.paintSelection = payload
  })

  builder.addCase(changeDataFields, (state, { payload }) => {
    state.dataFields = payload
  })
  builder.addCase(changeTags, (state, { payload }) => {
    state.tags = payload
  })
  builder.addCase(openBoothModal, (state, { payload }) => {
    state.isModalOpen = payload
  })
  builder.addCase(openBoothSettingsModal, (state, { payload }) => {
    state.isBoothSettingModalOpen = payload
  })
  builder.addCase(saveAssignedTktIds, (state, { payload }) => {
    state.assignedTktIds = payload
  })
  builder.addCase(saveUnAssignedTktIds, (state, { payload }) => {
    state.unAssignedTktIds = payload
  })
  builder.addCase(saveDeletedBoothIds, (state, { payload }) => {
    state.deletedBoothIds = payload
  })
  builder.addCase(floormapHoverObject, (state, { payload }) => {
    state.floormapHoverObjectData = payload
  })
  builder.addCase(changeUserPermisison, (state, { payload }) => {
    state.userPermissions = payload
  })
  builder.addCase(changeIsImporting, (state, { payload }) => {
    state.isImporting = payload
    console.log('isImportin121212g', state.isImporting)
  })
})
